module.exports = __webpack_public_path__ + "img/map.6b87e5fb.jpg";